exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menus[data-v-070ab1ac]{display:flex;align-items:center;justify-content:flex-end}.menus__item[data-v-070ab1ac]{font-size:.9230769231rem}.menus__item[data-v-070ab1ac]:nth-child(n+2){margin-left:20px}", ""]);

// exports
